export default "__VITE_ASSET__DzcrVgRJ__"